/* eslint-disable react/jsx-pascal-case */
import styled, { keyframes } from "styled-components";
import { Icon, RowView } from "../../../../Component/style/common_style";
import { useEffect, useState } from "react";
import Buy_Complete_Modal from "./Buy_Complete_Modal";
import { amountFormat } from "../../../../Component/tool/Tools";
import Buy_Modal from "./Buy_Modal";
import axios, { AxiosError } from "axios";
import url from "../../../../Component/server";

interface Item_List_Modal_Props {
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  seq: number;
}

interface BuyBtnProps {
  $count: number;
}

interface props_data_type {
  seq: number;
  live_seq: number;
  name: string;
  price: number;
  option_check: string;
  init_cnt: number;
  current_cnt: number;
  product_status: string;
  product_num: number | null;
  unique_option1: string[];
  unique_option2: string[];
}

const Item_List_Modal = (props: Item_List_Modal_Props) => {
  const { visible, handleModal } = props;
  const [BuyModal, setBuyModal] = useState(false);
  const [data, set_Data] = useState<props_data_type[]>([
    {
      seq: 1,
      live_seq: 1,
      name: "테스트 상품",
      price: 1000,
      option_check: "y",
      init_cnt: 40,
      current_cnt: 26,
      product_status: "판매노출",
      product_num: 1,
      unique_option1: ["화이트", "흑청"],
      unique_option2: ["32", "34"],
    },
    {
      seq: 2,
      live_seq: 2,
      name: "테스트 상품",
      price: 2000,
      option_check: "y",
      init_cnt: 40,
      current_cnt: 26,
      product_status: "판매노출",
      product_num: 2,
      unique_option1: ["화이트", "흑청"],
      unique_option2: ["32", "34"],
    },
  ]);
  const [selectedItem, setSelectedItem] = useState<props_data_type | null>(
    null
  ); // 선택된 아이템 상태 추가

  const openBuy = (item: props_data_type) => {
    setSelectedItem(item); // 선택된 아이템 저장
    setBuyModal(true); // 모달 열기
  };

  useEffect(() => {
    if (visible) {
      handleModal(true);
      load_productList();
    } else {
      setTimeout(() => {
        handleModal(false);
      }, 500);
    }
  }, [visible]);

  const closeModal = () => {
    handleModal(false);
  };

  const load_productList = async () => {
    axios
      .get(url.Communication_url.product_list, {
        params: { live_seq: props.seq },
      })
      .then((res) => {
        set_Data(res.data);
      })
      .catch((err) => {
        if (err instanceof AxiosError && err.response) {
          const errRes = err.response.data;
          switch (errRes?.statusCode) {
            case 403:
              // console.log("권한부족");
              break;
            default:
            // console.error(errRes);
          }
        } else {
          // console.error(err);
        }
      });
  };

  let count = 0;

  return (
    <BackgroundArea $visible={visible} $isOpen={visible} translate="no">
      <ModalBox $isOpen={visible} onClick={(e: any) => e.stopPropagation()}>
        <Title_Box>
          <div>상품목록</div>
          <Exit_Btn
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title_Box>
        <Content_Box>
          {data.length > 0 &&
            data.map((item, index) => {
              item.product_status !== "대기" && count++;
              return (
                <div key={index} style={{ width: "100%" }}>
                  {item.product_status !== "대기" && (
                    <Item_Box key={index}>
                      <Item_Data_Box>
                        <div>
                          {item.name.length > 14
                            ? `${item.name.slice(0, 14)}...`
                            : item.name}
                        </div>
                        <RowView style={{ color: "#EA2922", width: "100%" }}>
                          <div>{amountFormat(item.price)}원</div>
                          {item.product_num !== null &&
                            item.product_num !== undefined && (
                              <div
                                style={{ color: "#C6C6C6", fontSize: 14 }}
                                translate="no"
                              >
                                No.{item.product_num}
                              </div>
                            )}
                        </RowView>
                      </Item_Data_Box>
                      <Buy_Btn
                        as="button"
                        disabled={item.current_cnt === 0}
                        $count={item.current_cnt}
                        onClick={() => openBuy(item)} // 클릭 시 해당 item 전달
                      >
                        {item.current_cnt === 0 ? "품절" : "구매"}
                      </Buy_Btn>
                    </Item_Box>
                  )}
                </div>
              );
            })}
          {count === 0 && <Empty_Box>판매중인 상품이 없습니다.</Empty_Box>}
          <br />
          <br />
          <br />
          <br />
        </Content_Box>
      </ModalBox>
      <Buy_Modal
        visible={BuyModal}
        handleModal={setBuyModal}
        item={selectedItem}
        seq={props.seq}
        // load_productList={load_productList}
        type="item_list"
      />
      {/* item 전달 */}
    </BackgroundArea>
  );
};

export default Item_List_Modal;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
const BackgroundArea = styled.div<{ $visible: boolean; $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  position: absolute;
  display: ${(props) => (props.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  z-index: 99;
`;

const ModalBox = styled.div<{ $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  background-color: white;
  color: #454545;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  animation: ${(props) => (props.$isOpen ? slideUp : slideDown)} 0.5s ease;
  color: #1d1d1d;
  max-height: 95%;
  overflow: auto;
`;

const Title_Box = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #f0f0f0;
`;

const Exit_Btn = styled(Icon)`
  position: absolute;
  right: 30px;
  justify-self: flex-end;
  cursor: pointer;
`;

const Content_Box = styled.div`
  width: 100%;
  padding: 0px 16px;
  display: flex;
  position: relative;
  align-items: flex-start;
  box-sizing: border-box;
  flex-direction: column;
  font-size: 16px;
`;

const Item_Box = styled.div`
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
`;

const Item_Data_Box = styled.div`
  background-color: white;
  color: black;
  flex: 8;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 18px 16px;
  height: 100%;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  border-color: #f0f0f0;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
`;

const Buy_Btn = styled.div<BuyBtnProps>`
  background: ${(props) =>
    props.$count === 0
      ? "linear-gradient(to bottom right, #F8F8F8,#F8F8F8)"
      : "linear-gradient(90deg, #7955F0, #3209B9)"};
  color: ${(props) => (props.$count === 0 ? "#8E8E8E" : "white")};
  flex: 3;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
  border-width: 0px;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    &:active {
      opacity: 1;
    }
  }
  &:active {
    opacity: 0.5;
  }
`;

const Empty_Box = styled.div`
  height: 200px;
  width: 100%;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 50px;
`;
